const routers = [

    {
        path: '/system/user',
        name: 'user',
        component: resolve => require(['../views/System/User'], resolve)
    },
    {
        path: '/system/role',
        name: 'role',
        component: resolve => require(['../views/System/Role'], resolve)
    },
    {
        path: '/system/dictionary',
        name: 'dictionary',
        component: resolve => require(['../views/System/Dictionary'], resolve)
    },
    {
        path: '/system/organization',
        name: 'organization',
        component: resolve => require(['../views/System/Organization'], resolve)
    },
    {
        path: '/system/deviceManageLog',
        name: 'deviceManageLog',
        component: resolve => require(['../views/System/DeviceManageLog'], resolve)
    },
    {
        path: '/system/deviceControlLog',
        name: 'deviceControlLog',
        component: resolve => require(['../views/System/DeviceControlLog'], resolve)
    },
    {
        path: '/system/deviceLog',
        name: 'deviceLog',
        component: resolve => require(['../views/System/DeviceLog'], resolve)
    },
    {
        path: '/system/log',
        name: 'log',
        component: resolve => require(['../views/System/Log'], resolve)
    },
    {
        path: '/system/conversationLog',
        name: 'conversationLog',
        component: resolve => require(['../views/System/ConversationLog'], resolve)
    },
    {
        path: '/system/abnormalLog',
        name: 'abnormalLog',
        component: resolve => require(['../views/System/AbnormalLog'], resolve)
    },
    {
        path: '/system/appVersion',
        name: 'appVersion',
        component: resolve => require(['../views/System/AppVersion'], resolve)
    },
    {
      path: '/system/organization/enterpriseCustom',
      name: 'enterpriseCustom',
      component: resolve => require(['../views/System/EnterpriseCustom'], resolve)
    },
    {
      path: '/system/rom',
      name: 'rom',
      component: resolve => require(['../views/System/Rom'], resolve)
    },
    {
        path: '/system/setting',
        name: 'setting',
        component: resolve => require(['../views/System/setting'], resolve)
      },

]
export default routers



// WEBPACK FOOTER //
// ./src/routers/system.js